import { i18n } from "@/plugins/i18n";
import { TableFieldType, TableHeader } from "helix-vue-components";

export const pmpValidationDictionary = {
  custom: {
    port: {
      max: () =>
        `The ${i18n.t(
          "pmp.editIntegration.port"
        )} field should not be greater than 4 digits.`
    }
  }
};

export const PmpMetaHeader: TableHeader[] = [
  {
    value: "name",
    label: String(i18n.t("location.location")),
    fieldComponent: TableFieldType.string,
    class: "tdt__headers__fieldLong",
    sortable: false
  },
  {
    value: "license_number",
    label: String(i18n.t("location.license_number")),
    fieldComponent: TableFieldType.string,
    class: "tdt__headers__fieldLong",
    sortable: false
  },
  {
    value: "address1",
    label: String(i18n.t("location.address")),
    fieldComponent: TableFieldType.string,
    class: "tdt__headers__fieldLong",
    sortable: false
  },
  {
    value: "config_status",
    label: String(i18n.t("traceability.status")),
    fieldComponent: TableFieldType.string,
    class: "tdt__headers__fieldLong",
    sortable: false
  }
];

export const PmpIntegrationHistoryLogs: TableHeader[] = [
  {
    value: "created_at",
    label: String(i18n.t("pmp.historyLogs.date_time")),
    fieldComponent: TableFieldType.string,
    class: "tdt__headers__fieldLong"
  },
  {
    value: "modified_by.first_name",
    label: String(i18n.t("pmp.historyLogs.modified_by")),
    fieldComponent: TableFieldType.string,
    class: "tdt__headers__fieldLong"
  },
  {
    value: "modified_field",
    label: String(i18n.t("pmp.historyLogs.modified_field")),
    fieldComponent: TableFieldType.string,
    class: "tdt__headers__fieldLong"
  },
  {
    value: "modified_from",
    label: String(i18n.t("pmp.historyLogs.modified_from")),
    fieldComponent: TableFieldType.string,
    class: "tdt__headers__fieldLong"
  },
  {
    value: "modified_to",
    label: String(i18n.t("pmp.historyLogs.modified_to")),
    fieldComponent: TableFieldType.string,
    class: "tdt__headers__fieldLong"
  }
];
